import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import Activities_Left from './Activities_Left'

import Breadcrumb from '../../Breadcrumb/Main'
import Header from '../../headerone/Main'
import { Link } from 'react-router-dom'


function Festivals() {

    const [ActomaniaOpen, setActomania] = useState(true);
    const [ArtistaOpen, setArtista] = useState(false);
    const [AranyaOpen, setAranya] = useState(false);
    const [ChaturangaOpen, setChaturanga] = useState(false);
    const [PFCOpen, setPFC] = useState(false);
    const [LiteraryOpen, setLiterary] = useState(false);
    const [SahayogOpen, setSahayog] = useState(false);
    const [SargamOpen, setSargam] = useState(false);
    const [XCITEOpen, setXCITE] = useState(false);
    const [NisargaOpen, setNisarga] = useState(false);
    const [AcademicsOpen, setAcademics] = useState(false);

    const handleClick = (event) => {
        setActomania(false);
        setArtista(false);
        setAranya(false);
        setChaturanga(false);
        setPFC(false);
        setLiterary(false);
        setSahayog(false);
        setSargam(false);
        setXCITE(false);
        setNisarga(false);
        setAcademics(false);
        event(true);
    }



    const ActomaniaImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Actomania/1.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Actomania/2.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Actomania/3.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Actomania/4.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Actomania/5.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Actomania/6.png" },
    ]




    const ArtistaImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/1.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/2.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/3.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/4.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/5.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/10.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/11.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/8.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/9.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/7.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Artista/6.png" },
        
       
        

    ]

    const AranyaGalleryImg = [
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/4.png" },
        
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/5.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/3.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/1.png" },        
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/2.png" },
        
    ]

    const AranyaTallakonnamImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/talakonnam/7.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/talakonnam/8.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/talakonnam/9.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/talakonnam/10.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/talakonnam/11.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/talakonnam/12.jpg" },
        
    ]

    const AranyaMoolakonnamImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/moolakonnam/2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/moolakonnam/5.jpg" }        
    ]

    const ChaturangaImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Chaturangaclub/chess1.jpg" }
        
    ]
    const PFCImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Other/pfc.jpg" }

    ]

    const SargamImg = [
        
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/sargam2.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/sargam3.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/1.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/3.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/4.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/5.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/6.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/7.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/8.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/9.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/10.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/11.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/12.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/13.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/14.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Singing/sargam1.png" },


    ] 





    return (

        <>
            <Header />
            <Breadcrumb title='Home' subtitle="CLUBS" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <Row>
                            <div className="c-heading">
                                <h3>CLUBS</h3> <br />
                            </div>

                            <Col md={3} className='c-left custom-padding-color mb-4'>
                                <Activities_Left activeIndex={2} />
                            </Col>

                            <Col md={9} className='c-right'>

                                <Row className='mb-5 text-center'>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button'
                                            onClick={() => handleClick(setActomania)}
                                            aria-controls="c-Actomania"
                                            aria-expanded={ActomaniaOpen}>
                                            Actomania
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setArtista)}
                                            aria-controls="c-Artista"
                                            aria-expanded={ArtistaOpen}>
                                            Artista
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setAranya)}
                                            aria-controls="c-Aranya"
                                            aria-expanded={AranyaOpen}>
                                            Aranya
                                        </Button>
                                    </Col>


                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setChaturanga)}
                                            aria-controls="c-Chaturanga"
                                            aria-expanded={ChaturangaOpen}>
                                            Chaturanga
                                        </Button>
                                    </Col>


                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setPFC)}
                                            aria-controls="c-PFC"
                                            aria-expanded={PFCOpen}>
                                            PFC
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setLiterary)}
                                            aria-controls="c-Literary"
                                            aria-expanded={LiteraryOpen}>
                                            Literary
                                        </Button>
                                    </Col>


                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setSahayog)}
                                            aria-controls="c-Sahayog"
                                            aria-expanded={SahayogOpen}>
                                            Sahayog
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setSargam)}
                                            aria-controls="c-Sahayog"
                                            aria-expanded={SargamOpen}>
                                            Sargam
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setXCITE)}
                                            aria-controls="c-Sahayog"
                                            aria-expanded={XCITEOpen}>
                                            XCITE
                                        </Button>
                                    </Col>
                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setNisarga)}
                                            aria-controls="c-Sahayog"
                                            aria-expanded={NisargaOpen}>
                                            Nisarga
                                        </Button>
                                    </Col>
                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setAcademics)}
                                            aria-controls="c-Sahayog"
                                            aria-expanded={AcademicsOpen}>
                                            Academics
                                        </Button>
                                    </Col>

                               







                                </Row>


                                {/*Actomania */}
                                <div>
                                    {ActomaniaOpen && <Fade in={ActomaniaOpen}>
                                        <div className='c-lineheight2dot5'>

                                            <p>We have started this club on 22nd February 2017 with the idea of exploring the acting talent of students and to perform skits, drama and short films. As suggested by many students this club was named as Actomania.
                                                Our first short film-“Nithya–a tragic love story” was successfully completed in a week with the support of all the cast and Photography club (IDEAL SHOTS) and was rewarded the first prize at Short Film Contest in Abhisargaof IIIT-Sricity.</p>

                                            
                                            <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Story and Direction -Tarani, Y.Shravanthi </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Screenplay -Sai Sumanth</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Cinematography and Editing-Krishna.M.Venkat </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Dubbing artists - Manoj, Rakesh, Sai praneeth, Ramya, Sai Sumanth, Pranjal, Mouli, Krishna, M.Venkat </li>
                                            </ul>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallery</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {ActomaniaImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>



                                        </div>
                                    </Fade>
                                    }
                                </div>


                                {/*Artista*/}

                                <div>
                                    {ArtistaOpen && <Fade in={ArtistaOpen}>
                                        <div className='c-lineheight2dot5'>

                                            <p>The art club which caters to the talents in painting, sketching, crafting and are found ready to take up any opportunity to create something beautiful with a theme. </p>
                                            <h3 className='c-headline mt-5 mb-3'>Our Gallery</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {ArtistaImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Fade>
                                    }
                                </div>



                                {/*Aranya */}
                                <div>
                                    {AranyaOpen && <Fade in={AranyaOpen}>
                                        <div className='c-lineheight2dot5'>

                                            <h3 className='c-headline mt-5 mb-3'>Aranya - Trekking Club</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {AranyaGalleryImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>
                                            <h3 className='c-headline mt-5 mb-3'>Tallakonnam - October 9th 2016</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {AranyaTallakonnamImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>


                                            <h3 className='c-headline mt-5 mb-3'>Moolakonnam - August 13th 2016</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {AranyaMoolakonnamImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>



                                        </div>
                                    </Fade>
                                    }
                                </div>


                                {/*Chaturanga */}
                                <div>
                                    {ChaturangaOpen && <Fade in={ChaturangaOpen}>
                                        <div className='c-lineheight2dot5'>
                                            <p>The club has been formed on 27th January 2017. It had organized two tournaments within the first 3 months of its formation. One tournament is among juniors only which was conducted for fun in which no prizes were given. The second tournament is the INTRA IIT chess tournament among the four houses of IIT TIRUPATI clubs. It is an open tournament in which anyone are allowed to participate. There was a good response of it and no problem had been raised. The club progress in this semester is quite smooth and good.</p>
                                            <h3 className='c-headline mt-5 mb-3'>Our Gallary</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {ChaturangaImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Fade>
                                    }
                                </div>



                                {/*PFC */}
                                <div>
                                    {PFCOpen && <Fade in={PFCOpen}>
                                        <div className='c-lineheight2'>
                                            <p>Photography & Films Club, previously known as Ideal Shots, is a media club of students of IIT Tirupati. Currently, it consists of 80 students and is open to every student of the college. </p>
                                            <p>PFC has not only captured all our beautiful moments but also tried to provoke interest among amateur photographers by conducting various competitions and workshops.  </p>
                                            <p>View their portfolio at <Link className='c-link' to="https://www.flickr.com/photos/photographyclubiittp/albums">Flickr.</Link>  </p>

                                            <h3 className='c-headline mt-5 mb-3'>Stay connected with them </h3>
                                            <ul className='ms-3 c-lineheight2dot5 iarrow text-orange' >
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> <Link to="https://www.youtube.com/channel/UCgmHdDwotMlBsrgxJE9tIBA"> YouTube</Link> </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><Link to="https://www.facebook.com/photographyclubiittp">Facebook</Link></li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><Link to="https://www.instagram.com/pfciitt/">Instagram </Link></li>                                                
                                            </ul>

                                           
                                            <div className="grid col3 row wow fadeInUp  animated text-center mt-5" data-animation="fadeInUp" data-delay=".4s" >
                                                {PFCImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Fade>
                                    }
                                </div>



                                {/*Literary */}

                                <div>
                                    {LiteraryOpen && <Fade in={LiteraryOpen}>
                                        <div className='c-lineheight2'>
                                            <p className='c-link'>Will be updated Soon  </p>
                                        </div>
                                    </Fade>
                                    }
                                </div>



                                {/*Sahayog */}

                                <div>
                                    {SahayogOpen && <Fade in={SahayogOpen}>
                                        <div className='c-lineheight2'>
                                            <p>This club manages what IIT Tirupati is most proud of:  </p>
                                            <p>Its social initiatives — orphanage support, school, teaching and so forth. </p>
                                            <p><Link className='c-link' to="https://iittp.ac.in/component/content/2-uncategorised/220-social?Itemid=1060"> For More Info </Link></p>
                                        </div>
                                    </Fade>
                                    }
                                </div>


                                {/*Sargam */}

                                <div>
                                    {SargamOpen && <Fade in={SargamOpen}>
                                        <div className='c-lineheight2'>
                                            <p>The Music Club caters to interests in singing, composing or creating and presenting anything which appeals to the ears. </p>
                                            <h3 className='c-headline mt-5 mb-3'>KalaTarang </h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {SargamImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>


                                    </Fade>
                                    }
                                </div>
                                

                                {/*Literary */}

                                <div>
                                    {XCITEOpen && <Fade in={XCITEOpen}>
                                        <div className='c-lineheight2'>
                                            <p className='c-link'>Will be updated Soon  </p>
                                        </div>
                                    </Fade>
                                    }
                                </div>

                                 {/*Nisarga */}

                                 <div>
                                    {NisargaOpen && <Fade in={NisargaOpen}>
                                        <div className='c-lineheight2'>
                                            <p className='c-link'>Will be updated Soon  </p>
                                        </div>
                                    </Fade>
                                    }
                                </div>

                                 {/*Academics */}

                                 <div>
                                    {AcademicsOpen && <Fade in={AcademicsOpen}>
                                        <div className='c-lineheight2'>
                                            <p className='c-link'>Will be updated Soon  </p>
                                        </div>
                                    </Fade>
                                    }
                                </div>





                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Festivals;
